import React from 'react';
import './Heading.styles.scss';

export const Heading = ({ children }) => (
  <div className="heading-wrapper">{children}</div>
);
